import angular from 'angular';
import eventProductPageComponent from './eventProductPage.component';
import translateModuleName from '../../translation';
import './eventProductPage.css';

let module = angular.module('recaps.components.eventProductPage', [
  translateModuleName,
]);

module.component('eventProductPage', eventProductPageComponent);

export default module;
